import {
  Affix,
  Container,
  Content,
  Divider,
  Dropdown,
  Header,
  Icon,
  IconButton,
  Nav,
  Navbar,
  Panel,
  PanelGroup,
  SelectPicker,
  Sidebar,
  Sidenav,
  Tooltip,
  Whisper,
} from 'rsuite';
import { Link, Router } from 'utils/with-i18next';
import React, { useContext, useEffect, useState } from 'react';

import AvatarComponent from 'components/Avatar';
import Footer from 'components/Footer';
import PropTypes from 'prop-types';
// import { PropertyApi } from 'services/api/property';
import SlackFeedback from 'components/SlackFeedback';
import WelcomeModal from 'components/Modals/Welcome';
import ChatbotHide from 'components/ChatbotHide';
import DashboardFilters from 'containers/DashboardLeads/DashboardFilters';
import { DashboardContext } from 'contexts/LayoutDashboardContext';
import Styles from './styles.js';
import InsightsButton from 'components/InsightsButton';

function DashboardLayout({ children, pageId, handleLogout, currentUser }) {
  const [expand, setExpand] = useState(false);
  const [openWelcomeModal, setOpenWelcomeModal] = useState(false);
  const { dashboardState, dashboardDispatch } = useContext(DashboardContext);

  useEffect(() => {
    if (currentUser?.email) {
      if (!currentUser?.seenWelcomeModal) {
        setOpenWelcomeModal(false);
      }
    }
  }, [currentUser]);

  const navLinks = [
    {
      pageId: 'dashboard',
      title: 'Analytics',
      icon: '/static/icons/dashboard.png',
      link: '/dashboard',
      hide: false,
      dummy: false,
    },
    {
      pageId: 'properties',
      title: 'Properties',
      icon: '/static/icons/property-icon.png',
      link: '/dashboard/properties',
      hide: false,
      dummy: false,
    },
    {
      pageId: 'bookings',
      title: 'Convert',
      icon: '/static/icons/bookings-icon.png',
      link: '/dashboard/bookings',
      hide: false,
      dummy: false,
    },
    {
      pageId: 'tickets',
      title: 'Engage',
      icon: '/static/icons/tickets-icon.png',
      link: '/dashboard/tickets',
      hide: false,
      dummy: false,
    },
    // {
    //   pageId: 'transactions',
    //   title: 'Payout Summary',
    //   icon: '/static/icons/payment-icon.png',
    //   link: '/dashboard/transactions',
    //   hide: true,
    //   dummy: false,
    // },
    {
      pageId: 'incomeManagement',
      title: 'Income Management',
      icon: '/static/icons/payment-icon.png',
      link: '/dashboard/income-management',
      hide: false,
      dummy: false,
    },
    {
      pageId: 'rentCalculator',
      title: 'Price',
      icon: '/static/icons/rent-calculator.png',
      link: '/get-rent-estimate',
      hide: false,
      dummy: false,
    },
    {
      pageId: 'settings',
      title: 'Settings',
      icon: '/static/icons/rent-calculator.png',
      link: '/dashboard/settings',
      hide: false,
      dummy: true,
    },
  ];

  // useEffect(() => {
  //   PropertyApi.getProperties().then(res => {
  //     if (res.data.filter(p => p.currentStatus === 'initiated' && p.currentStatus === 'submitted').length > 0) {
  //       setNavLinks(
  //         navLinks.map(n => ({
  //           ...n,
  //           hide: false,
  //         }))
  //       );
  //     }
  //   });
  // }, []);

  useEffect(() => {
    // eslint-disable-next-line no-undef
    // if (Notifuse && currentUser?.notification) {
    //   // eslint-disable-next-line no-undef
    //   Notifuse.init({
    //     projectId: `${currentUser?.notification?.projectId}`,
    //     userId: `${currentUser?.notification?.userId}`,
    //     userHmac: `${currentUser?.notification?.userHmac}`,
    //     onClickMessage: message => {
    //       switch (message.notificationId) {
    //         case 'welcome':
    //           setOpenWelcomeModal(false);
    //           break;
    //         default:
    //       }
    //     },
    //     bellSelector: '#notifuse-bell',
    //   });
    // }
  });

  return (
    <>
      <ChatbotHide debug={true} show={false} />
      <main>
        <Container style={{ background: '#f8f8f8', height: 'auto', minHeight: '100vh' }}>
          {/* Sidebar for width < 780  */}
          <WelcomeModal show={openWelcomeModal} setClose={setOpenWelcomeModal} />
          <Sidenav
            className={`side-nav-${expand ? 'open' : 'close'}`}
            id="side-nav-779"
            // style={{ backgroundColor: 'white', zIndex: '100', width: '100%', maxWidth: '400px', position: 'absolute' }}
          >
            <Sidenav.Header className="db-logo" style={{ margin: '0.5em 0.4em 0 0', display: 'flex' }}>
              <Icon
                icon="close"
                style={{ float: 'left', fontSize: '2em', marginRight: '20px' }}
                onClick={() => setExpand(false)}
              />
              <Link href={'/dashboard/'} passHref>
                <img src="/static/images/logo.png"></img>
              </Link>
            </Sidenav.Header>
            <Sidenav activeKey={pageId} expanded={expand} appearance="subtle">
              <Sidenav.Body className="db-sidenav">
                <Nav activeKey={pageId}>
                  {navLinks
                    .filter(i => !i.hide && !i.dummy)
                    .map((item, idx) => (
                      <Link key={idx} href={item.link} passHref>
                        <Nav.Item
                          eventKey={item.pageId}
                          active={item.pageId === pageId}
                          onClick={() => setExpand(!expand)}>
                          <div className="flex">
                            <img src={item.icon} className="" />
                            <span>{item?.title}</span>
                          </div>
                        </Nav.Item>
                      </Link>
                    ))}
                </Nav>
              </Sidenav.Body>
            </Sidenav>
          </Sidenav>

          {/* Sidebar for width > 780 */}
          <Sidebar id="side-bar-780" className="db-sidebar" width={expand ? 260 : 86}>
            <Affix style={{ background: '#fff' }}>
              <Sidenav.Header className="db-logo">
                <Link href={'/dashboard/'} passHref>
                  {expand ? <img src="/static/images/logo.png"></img> : <img src="/static/images/logo-small.png"></img>}
                  {/*<img src="/static/images/logo.png"></img>*/}
                </Link>
              </Sidenav.Header>
              <Sidenav activeKey={pageId} expanded={expand} appearance="subtle">
                <Sidenav.Body className="db-sidenav" style={{ width: expand ? '260px' : '86px' }}>
                  <Nav activeKey={pageId}>
                    {navLinks
                      .filter(i => !i.hide && !i.dummy)
                      .map((item, idx) => (
                        <Link key={idx} href={item.link} passHref>
                          <Nav.Item
                            eventKey={item.pageId}
                            active={dashboardState.DashboardTab.module !== 'insights' && item.pageId === pageId}
                            onClick={() => {
                              if (dashboardState.DashboardTab.module === 'insights') {
                                dashboardDispatch({
                                  type: 'setModule',
                                  payload: 'analytics',
                                });
                              }
                            }}
                            style={{ height: '55px' }}>
                            <div className="flex">
                              <Whisper trigger={expand ? 'none' : 'hover'} speaker={<Tooltip>{item?.title}</Tooltip>}>
                                <img src={item.icon} className="" />
                              </Whisper>
                              <span className={!expand ? 'hide' : ''}>{item?.title}</span>
                            </div>
                          </Nav.Item>
                        </Link>
                      ))}
                  </Nav>
                  {/*<Whisper trigger="hover" speaker={<Tooltip>{expand?"Collapse Menu":"Expand Menu"}</Tooltip>}>
                    <Sidenav.Toggle className="db-logo" expanded={expand} onToggle={(expanded) => setExpand(expanded)}/>
                  </Whisper>*/}
                </Sidenav.Body>
              </Sidenav>
              {/* <Navbar appearance="subtle" className="nav-toggle">
                <Navbar.Body>
                  <Nav pullRight>
                    <Nav.Item onClick={() => setExpand(!expand)}>
                      <Icon icon={expand ? 'angle-left' : 'angle-right'} />
                    </Nav.Item>
                  </Nav>
                </Navbar.Body>
              </Navbar> */}
            </Affix>
          </Sidebar>

          <Container id="container-opacity" style={{ height: '100%', width: '100%' }}>
            <Header>
              <Navbar className="db-navbar">
                <Icon
                  id="icon-779"
                  icon="bars"
                  style={{ float: 'left', margin: '0.3em 1em 0 0em', fontSize: '2em' }}
                  onClick={() => setExpand(!expand)}></Icon>
                <Navbar.Header>
                  <Nav>
                    {/* If on dashboard, checks context to either display insights or analytics accordingly as title */}
                    {pageId === 'dashboard'
                      ? dashboardState.DashboardTab.module === 'insights'
                        ? 'Insights'
                        : 'Analytics'
                      : navLinks.find(i => i.pageId === pageId)?.title}
                  </Nav>
                </Navbar.Header>
                <Nav pullRight justified style={{ zIndex: 1 }}>
                  {pageId === 'dashboard' && <DashboardFilters />}
                  <div className="-mt-1">
                    <InsightsButton origin={pageId} />
                  </div>
                  <span id="notifuse-bell">
                    <Icon
                      className="animated headShake -mt-1"
                      style={{ padding: '10px 20px', fontSize: '22px', color: '#c5c6c7', cursor: 'pointer' }}
                      size="2x"
                      icon="bell-o"></Icon>
                  </span>
                  <Dropdown
                    placement="bottomEnd"
                    className="animated fadeIn"
                    renderTitle={() => {
                      return currentUser?.displayName && <AvatarComponent size="md" name={currentUser?.displayName} />;
                    }}>
                    <Dropdown.Item panel style={{ padding: 10, width: 160 }}>
                      <p>Signed in as</p>
                      <strong>{currentUser?.displayName}</strong>
                    </Dropdown.Item>
                    {/* <Dropdown.Item divider /> */}
                    {/* <Dropdown.Item>Personality Profile</Dropdown.Item> */}
                    <Dropdown.Item divider />
                    <Dropdown.Item onSelect={() => Router.push('/dashboard/settings?tab=personal')}>
                      Account Settings
                    </Dropdown.Item>
                    {/* <Dropdown.Item onSelect={() => Router.push('/dashboard/settings?tab=plans')}>
                        Plans & Bilings
                      </Dropdown.Item> */}
                    <Dropdown.Item onSelect={handleLogout}>Sign Out</Dropdown.Item>
                  </Dropdown>
                </Nav>
                <Navbar.Body></Navbar.Body>
                <br></br>
                <Divider style={{ marginBottom: 0 }}></Divider>
              </Navbar>
            </Header>
            <Content className="db-content">{children}</Content>
            <Footer />
          </Container>
        </Container>
        <SlackFeedback user={currentUser}></SlackFeedback>
      </main>
      <Styles />
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
  bgImage: PropTypes.bool,
  currentUser: PropTypes.object,
  handleLogout: PropTypes.func,
};

export default DashboardLayout;
